import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { AppEventDispatcher } from './../../../utils/AppEventDispatcher';
import { TweenMax, Quint } from 'gsap';
import { Router } from '@angular/router';
import { EventTypes } from './../../../shared/EventTypes';
import { Question } from './../../../autentication/models/question';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ChangeSecurityQuestionsService } from './../change-security-questions.service';
import { ChangeSecurityQuestionsEventType } from './../change-security-questions.event.type';
import { ChangeSecurityQuestions } from './../model/change-security-questions';

@Component({
	selector: 'app-change-questions',
	templateUrl: './change-questions.component.html',
	styleUrls: ['./change-questions.component.styl'],
	encapsulation: ViewEncapsulation.None
})

export class ChangeQuestionsComponent implements OnInit, OnDestroy {
	view = '[data-component="change-questions"]';
	active = false;
	loading = false;
	canSend = false;

	@Input() changeQuestionsData: ChangeSecurityQuestions;

	questionActive = 0;
	questionsCombo = {};
	questions: Question[] = [];
	answers: Question[] = [];

	form: FormGroup;

	constructor(private router: Router, private changeSecurityQuestionsService: ChangeSecurityQuestionsService, private formBuilder: FormBuilder) {
		this.form = formBuilder.group({
			'question': [null, Validators.required],
			'answer': [null, Validators.required]
		});
	}

	ngOnInit() {
		AppEventDispatcher.listen(ChangeSecurityQuestionsEventType.STEPS.CHANGE_SECURITY_QUESTIONS, (data: any) => {
			if (data.show) {
				this.getSecurityQuestions(data);
			}
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(ChangeSecurityQuestionsEventType.STEPS.CHANGE_SECURITY_QUESTIONS);
	}

	getSecurityQuestions(dataShow) {
		this.preload(true);
		this.changeSecurityQuestionsService.getForRegistrationSecurityQuestions().subscribe(data => {
			this.questionsCombo = data;
			this.questionsCombo = this.sliceQuestions(this.questionsCombo, 6);
			this.questions = this.questionsCombo[0];
			this.active = true;
			this.show();
			this.preload(false);
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});
	}

	sliceQuestions(base, max) {
		const res = [];
		for (let i = 0; i < base.length; i = i + (max)) {
			res.push(base.slice(i, (i + max)));
		}
		return res;
	}

	show() {
		const interval = setInterval(() => {

			if ($(this.view).length > 0) {
				const containerHeight = this.getStepHeight();

				TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut });
				TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut });
				TweenMax.to(this.view + ' .question-step', .8, { left: 0, ease: Quint.easeOut });

				clearInterval(interval);
			}

		}, 10);
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

	hide() {
		TweenMax.to(this.view, .8, {
			left: '-100%', ease: Quint.easeOut, onComplete: () => {
				this.active = false;
			}
		});
	}

	nextAnswer() {
		TweenMax.to(this.view + ' .question-step', .8, {
			left: '-100%', ease: Quint.easeOut, onComplete: () => {
				const questionSelected = this.questions[this.form.value.question];
				const answer = {
					code: questionSelected.code,
					description: questionSelected.description,
					answer: this.form.value.answer
				};
				this.answers.push(answer);
				this.questionActive++;
				this.form.controls.question.setValue(null);
				this.form.controls.answer.setValue('');
				this.canSend = false;

				if (this.questionActive === 3) {
					this.send();
				} else {
					this.questions = this.questionsCombo[this.questionActive];
					$(this.view + ' .question-step').css('left', '100%');
					TweenMax.to(this.view + ' .question-step', .8, {
						left: 0, ease: Quint.easeOut, onComplete: () => {
						}
					});
				}
			}
		});
	}

	answerChange(event) {
		if ((this.form.controls.answer.valid) && (this.form.controls.question.valid)) {
			this.canSend = true;
		} else {
			this.canSend = false;
		}
	}

	send() {
		this.hide();
		this.changeQuestionsData.questions = this.answers;
		AppEventDispatcher.dispatch(ChangeSecurityQuestionsEventType.STEPS.CHANGE_SECURITY_QUESTIONS_CONFIRM, { show: true });
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{ element: '[data-component="change-security-questions"] .content', show: active, delay: delay });
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/change-security-questions/change-questions/change-questions.component.ts